import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import ja from "vuetify/lib/locale/ja";
import en from "vuetify/lib/locale/en";

Vue.use(Vuetify);

const locales = { ja, en };
const fallbackLang = "ja";
const browserLang = window.navigator.language.toLowerCase().split("-")[0];
const currentLanguage = Object.keys(locales).includes(browserLang) ? browserLang : fallbackLang;

export default new Vuetify({
  lang: {
    locales,
    current: currentLanguage,
  },
  icons: {
    iconfont: "mdi",
  },
});
